module.exports = __webpack_public_path__ + "static/media/rings.210f64d3.jpg";